import * as types from "./types";

export const hideLeftBar = () => ({
    type: types.HIDE_LEFT_BAR,
    isVisible: false
});

export const showLeftBar = () => ({
    type: types.SHOW_LEFT_BAR,
    isVisible: true
});